// SteffiAvatarDemo.jsx
import React from "react";
import SteffiAvatar from "./SteffiAvatar";

export default function SteffiAvatarDemo() {
  return (
    <div className="flex flex-col items-center gap-6">
     
      <SteffiAvatar mouth="smile" eyes="open" extra="none" />

       
        <SteffiAvatar mouth="smile" eyes="closed" extra="none" />

        <SteffiAvatar mouth="talk1" eyes="open" extra="none" />

        <SteffiAvatar mouth="neutral" eyes="closed" extra="sleep" />
    </div>
  );
}